export const fmtEur = (v) => Number(v || 0).toLocaleString('fr-FR', {
  minimumFractionDigits: 2, maximumFractionDigits: 2,
}) + ' €';

export const fmtDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit',
    });
  } catch { return '—'; }
};

export const STATUS_FILTERS = [
  { value: 'awaiting_signature', label: 'En attente signature', color: 'bg-blue-100 text-blue-800' },
  { value: 'pending_validation', label: 'À valider', color: 'bg-amber-100 text-amber-800' },
  { value: 'validated', label: 'Validées', color: 'bg-emerald-100 text-emerald-800' },
  { value: 'refused', label: 'Refusées', color: 'bg-red-100 text-red-800' },
  { value: 'all', label: 'Toutes', color: 'bg-slate-100 text-slate-800' },
];

export const EMAIL_LOG_TYPE_STYLE = {
  envoi_signature: 'bg-blue-700 text-white border-blue-900',
  relance: 'bg-orange-600 text-white border-orange-800',
  renvoi_pdf_signe: 'bg-purple-700 text-white border-purple-900',
  rappel_j7: 'bg-slate-700 text-white border-slate-900',
  rappel_j1: 'bg-slate-700 text-white border-slate-900',
};
